<template>
    <div class="finder-component" :class="{ 'items-loading': itemsLoading }">
        <form :action="'/' + selectedCategory.slug || '/search'" method="get">

            <input type="hidden" name="facets" :value="Object.values(facets).filter(f => !!f).join( ',' )" />
            <input v-if="categories.length > 1" type="hidden" name="categoryId" :value="selectedCategory.id || ''"/>

            <div class="box-select">

                <select class="finder" @change="setCategory($event)" v-show="categories.length > 1">
                    <option value="0" disabled selected>{{ $translate("Finder::Template.chooseCategory") }}</option>
                    <option v-for="(category, index) in categories" :key="index" :rel="category.id" :value="category.slug">
                        {{ category.name }}
                    </option>
                </select>

                <template v-for="n in selectFields" v-if="isLoading">
                    <select class="finder-select loading">
                        <option value="">{{ $translate("Finder::Template.loading") }}</option>
                    </select>
                </template>

                <template v-for="(group, index) in propertyGroups" v-if="!isLoading">
                    <select class="finder-select" v-show="group.categoryId === selectedCategory.id" @change="setFacet(group.propertyGroupId, $event)" :disabled="!hasFacet(group.propertyGroupId) || itemsLoading">
                        <option value="">
                            {{ group.name }} {{ $translate("Finder::Template.choose") }}
                        </option>
                        <option v-for="(property, index) in group.properties" :key="'p' + index" :value="property.id" v-if="hasFacetValue(group.propertyGroupId, property.id)">
                            {{ property.names[0].name }}
                        </option>
                    </select>
                </template>

                <template v-for="n in selectFields" v-if="!isLoading && (selectedCategory.id === 0 && categories.length)">
                    <select class="finder-select preselect">
                        <option value="0">{{ $translate("Finder::Template.categoryFirst") }}</option>
                    </select>
                </template>
            </div>

            <div class="box-button">
                <button :disabled="items === 0 || isLoading">
                    <span id="countCarpets" v-text="items" v-if="showItemCount"></span> {{ $translate("Finder::Template.buttonText") }}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    data()
    {
        return {
            items: 0,
            selectFields: 3,
            showItemCount: true,
            useProperties: false,
            isLoading: true,
            itemsLoading: false,
            lang: "de",
            facets: {},
            facetCounts: {},
            categories: [],
            propertyGroups: [],
            selectedCategory: {
                slug: "",
                id: 0
            }
        }
    },

    created()
    {
        this.getFinderData();
    },

    methods:
    {
        setCategory(evt) {
            this.selectedCategory.slug = evt.target.value;
            this.selectedCategory.id = parseInt(evt.target.options[evt.target.selectedIndex].getAttribute("rel"));
            if(this.showItemCount)
            {
                this.getItemCount()
            }
        },

        setFacet: function(facetId, evt) {
            const value = evt.target.value;
            if(value === "")
            {
                delete this.facets[facetId];
            }
            else
            {
                this.facets[facetId] = value;
            }

            if(this.showItemCount)
            {
                this.getItemCount()
            }
        },

        getFinderData()
        {
            this.isLoading = true;
            this.fetch("/rest/finder")
                .then(response =>
                {
                    this.selectedFields = response.selectedFields;
                    this.lang = response.lang;
                    this.showItemCount = response.showItemCount;
                    this.useProperties = response.useProperties;
                    this.categories = response.categories;
                    this.propertyGroups = response.propertyGroups;

                    if(this.categories.length === 1)
                    {
                        this.selectedCategory.id = parseInt(this.categories[0].id);
                        this.selectedCategory.slug = this.categories[0].slug;
                    }

                    this.isLoading = false;
                })
                .catch(error =>
                {
                    console.error("Could not fetch data for finder: " + error + ".");
                });
        },

        getItemCount()
        {
            const params = {
                categoryId: this.selectedCategory.id || "",
                facets: Object.values(this.facets).filter(f => !!f).join(",") || ""
            };

            this.itemsLoading = true;

            this.fetch("/rest/finder/items", params)
                .then(response => {
                    this.items = response.count;
                    this.facetCounts = response.facets;
                    this.itemsLoading = false;
                })
                .catch(error => {
                    console.error("Could not fetch item count for finder: " + error + ".");
                    this.itemsLoading = false;
                });
        },

        isCompleteSelection()
        {
            return this.propertyGroups
                .filter(group => group.categoryId === this.selectedCategory.id)
                .every(group => !!this.facets[group.propertyGroupId]);
        },

        hasFacet(facetId)
        {
            return !this.facetCounts[facetId] || this.facetCounts[facetId].count > 0 || this.isCompleteSelection();
        },

        hasFacetValue(facetId, facetValueId)
        {
            return !this.facetCounts[facetId] || this.facetCounts[facetId].values[facetValueId];
        },

        fetch(url, params)
        {
            const paramString = Object.keys(params || {}).map(paramKey => `${paramKey}=${params[paramKey]}`).join("&");

            return new Promise((resolve, reject) =>
            {
                $.ajax(
                    url + (paramString.length > 0 ? `?${ paramString }` : ""),
                    {
                        method:     "GET",
                        dataType:   "json"
                    })
                    .done(resolve)
                    .fail(reject);
            })
        }
    }
}
</script>
